export default __webpack_public_path__ + "static/media/equip.12f73259.png";